<template>
  <b-row>
    <b-col cols="12" lg="3">
      <p class="font-weight-bold">{{ Title }}</p>
    </b-col>
    <b-col cols="12" lg="2">
      <p v-if="isLoaded">{{ Value }}</p>
    </b-col>
    <b-col cols="12" lg="7">
      <div v-if="Classification !== null && Classification !== undefined" class="d-flex">
        <b-img
          class="result-sign"
          v-if="Classification === CLASSIFICATION.NemTudjukMinositeni"
          src="../../assets/img/result/nodecision.svg"
        >
        </b-img>
        <b-img
          class="result-sign"
          v-else-if="Classification === CLASSIFICATION.NemAdhatoKiKkvMinosito"
          src="../../assets/img/result/rejected.svg"
        >
        </b-img>
        <b-img v-else-if="!isLoaded" class="svg-spinner" src="../../assets/img/result/loading.svg"> </b-img>
        <b-img class="result-sign" v-else src="../../assets/img/result/approved.svg"></b-img>
        <p class="my-0 ml-4" :class="classObject" v-html="decisionSelected()"></p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { CLASSIFICATION } from '../../assets/enums/result.js'

export default {
  data() {
    return {
      CLASSIFICATION: CLASSIFICATION
    }
  },
  computed: {
    classObject() {
      return {
        'text-green':
          this.Classification === CLASSIFICATION.Micro ||
          this.Classification === CLASSIFICATION.Kis ||
          this.Classification === CLASSIFICATION.Kozep ||
          this.Classification === CLASSIFICATION.Nagy,
        'text-yellow': this.Classification === CLASSIFICATION.NemTudjukMinositeni,
        'text-red': this.Classification === CLASSIFICATION.NemAdhatoKiKkvMinosito
      }
    }
  },
  methods: {
    classSelected() {
      if (
        this.Classification === CLASSIFICATION.Micro ||
        this.Classification === CLASSIFICATION.Kis ||
        this.Classification === CLASSIFICATION.Kozep
      ) {
        return 'approved'
      } else if (this.Classification === CLASSIFICATION.NemTudjukMinositeni) {
        return 'no-decision'
      } else if (
        this.Classification === CLASSIFICATION.Nagy ||
        this.Classification === CLASSIFICATION.NemAdhatoKiKkvMinosito
      ) {
        return 'rejected'
      } else {
        return 'loading'
      }
    },
    decisionSelected() {
      switch (this.Classification) {
        case CLASSIFICATION.Micro:
          return 'Megfelel a <strong class="text-green">mikrovállalkozás</strong> feltételeinek'

        case CLASSIFICATION.Kis:
          return 'Megfelel a <strong class="text-green">kisvállalkozás</strong> feltételeinek'

        case CLASSIFICATION.Kozep:
          return 'Megfelel a <strong class="text-green">középvállalkozás</strong> feltételeinek'

        case CLASSIFICATION.NemTudjukMinositeni:
          return '<strong class="text-yellow">Nem egyértelműen</strong> feletethető meg a kkv kritériumainak'

        case CLASSIFICATION.Nagy:
          return 'Megfelel a <strong class="text-green">nagyvállalat</strong> feltételeinek'

        case CLASSIFICATION.NemAdhatoKiKkvMinosito:
          return 'Sajnos <strong class="text-red">nem felel meg</strong> a kkv követelményének'

        default:
          return 'Besorolás folyamatban, kérjük várjon'
      }
    }
  },
  props: {
    Classification: {
      type: String,
      required: true
    },
    Title: {
      type: String,
      required: true
    },
    Value: {
      type: String,
      required: true
    },
    isLoaded: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/Result.css';

.result-sign {
  width: 24px;
}

@media (max-width: 993px) {
  h1 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    line-height: 24px;
  }

  h3 {
    font-size: 16px;
    line-height: 24px;
  }

  p {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  }
}
</style>
